<app-tool-loader [isLoading]="isLoading()" [positionUnset]="true">
      <p-toolbar>
            <ng-template pTemplate="start">
                <div class="flex items-center gap-2 toolbar-menu">
                    
                    <p-selectButton [options]="resultsDisplay" [(ngModel)]="selectedResultDisplay"
                    (onChange)="onSelectedResultDisplayUpdated($event)" [allowEmpty]="false">
                    </p-selectButton>

                    <app-single-load-results
                        [loadCases]="loadCases" 
                        (loadCaseSelected)="setLoadCase($event); onSelectedResultDisplayUpdated($event)"
                        [stateStore]="bucklingSummaryResultsStore"
                        [signalRChange]="signalRChange" 
                    ></app-single-load-results>

                </div>
            </ng-template>

            <ng-template pTemplate="end">
                @if (totalBuckledLength != null) {
                <label class="mr-4" [class.validation-error]="totalBuckledLength > 0">Total Buckled Length: {{ totalBuckledLength | number:'1.0-2' }} {{ longLengthUnit }}</label>
                }
            </ng-template>
      </p-toolbar>

    @if (selectedResultDisplay === 'plot') {
    <app-single-load-plot 
        [xAxisTitle]="xAxisTitle" 
        [columnDefs]="columnDefs" 
        [data]="results"
        [depthUnit]="depthUnit"
        [plotName]="plotName"
        [plotTitle]="'Buckling Summary'"
        [singleLoadPlotStore]="bucklingSummaryResultsStore"
    ></app-single-load-plot>
    }

    <app-single-load-grid  
        [hidden]="selectedResultDisplay !== 'grid'"
        [rowData]="results"
        [columnDefinitions]="columnDefinitions"
        tableName="Buckling Summary" 
        gridName="Buckling Summary"
    ></app-single-load-grid>

    <p-dialog [draggable]="false" [visible]="errorMsg != null" [closable]="false" appendTo="self">
        <i class="pi pi-exclamation-circle pr-1"></i>
        <label>{{ errorMsg }}</label>
        <br />
        <br />
    </p-dialog>
  
    @if (displacementResults != null) {
        <app-perivis-validation [errors]="displacementResults[0]?.errors" />
    }
</app-tool-loader>